import { useNavigate } from 'react-router-dom';
import PageHeader from '@/components/Layout/PageHeader.jsx';

export default function CtasCtesPlaceholder({ title, category }) {
  const navigate = useNavigate();
  const breadcrumbs = [
    { label: 'Ctas Ctes' },
    ...(category ? [{ label: category }] : []),
    { label: title },
  ];

  return (
    <div className="min-h-screen bg-[rgba(var(--bg),0.95)] pb-16">
      <div className="mx-auto max-w-[1400px] px-4 pb-10 pt-8">
        <PageHeader title={title} subtitle="En construcción" breadcrumbs={breadcrumbs} />

        <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.92)] p-8 shadow-[0_18px_34px_-20px_rgba(var(--shadow),0.45)]">
          <div className="flex flex-col gap-4">
            <p className="text-sm text-[rgb(var(--muted))]">
              En construcción. Esta sección estará disponible próximamente.
            </p>
            <div>
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center rounded-xl border border-[rgba(var(--border),0.8)] bg-[rgb(var(--panel))] px-4 py-2 text-sm font-semibold text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--subpanel),0.9)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
              >
                Volver
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
